import { Injectable } from '@angular/core';
import { HttpStaffProvider } from '../providers/http-staff';

/**
 * Generated class for the FamilyPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Injectable()
export class StaffAction {

  constructor(
		private httpStaffProvider:HttpStaffProvider,
  	) {
  }

  /**
   * 一覧取得
   */
  getList(conditions){
    return this.httpStaffProvider.getList(conditions);
  }

  /**
   * １件取得
   */
  getOne(conditions){
    return this.httpStaffProvider.getOne(conditions);
  }

  /**
   * 登録処理
   */
  register(data){
    return this.httpStaffProvider.register(data);
  }

  /**
   * アイコン保存
   */
  iconSave(data){
    return this.httpStaffProvider.iconSave(data);
  }

  /**
   * 登録処理
   */
  passwordReset(userId){
    return this.httpStaffProvider.passwordReset(userId);
  }

  /**
   * 同意書の文言登録
   */
  saveSignMessage(data) {
    return this.httpStaffProvider.saveSignMessage(data);
  }

  getSignMessage() {
    return this.httpStaffProvider.getSignMessage();
  }
}



// WEBPACK FOOTER //
// ./src/actions/staff.action.ts